/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringregexaspect7Inputs */

const de__class_stringregexaspect7 = /** @type {(inputs: _Class_Stringregexaspect7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`regex`)
};

/**

* @param {_Class_Stringregexaspect7Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringregexaspect7 = /** @type {((inputs?: _Class_Stringregexaspect7Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringregexaspect7Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringregexaspect7(inputs)
});
export { _class_stringregexaspect7 as "_class_StringREGEXAspect" }